export default function AboutUsSection() {
    return (
        <section className="px-4 py-8 bg-secondary text-black rounded-2xl lg:min-h-screen lg:px-14">
            <div className="container mx-auto grid gap-8 max-w-7xl lg:grid-cols-2 items-center">
                {/* Text Content */}
                <div className="flex flex-col justify-center gap-6">
                    <div>
                        <h1 className="text-primary font-bold text-3xl sm:text-4xl leading-snug">
                            About us
                        </h1>
                        <p className="text-base sm:text-lg mt-2">
                            Tech Space is a vibrant and rapidly growing tech community committed to
                            empowering individuals to launch and advance their technology. Our mission
                            is to make tech education accessible and practical through.
                        </p>
                    </div>

                    {/* Feature Columns */}
                    <div className="flex flex-col md:flex-row gap-6">
                        <div className="space-y-4">
                            <div>
                                <strong className="text-primary">Free Trainings:</strong>
                                <p className="text-sm">Comprehensive programs covering various tech disciplines.</p>
                            </div>
                            <div>
                                <strong className="text-primary">Community Hangouts & Tips:</strong>
                                <p className="text-sm">Networking events fostering collaborations.</p>
                            </div>
                            <div>
                                <strong className="text-primary">Events:</strong>
                                <p className="text-sm">Engaging gatherings like our flagship "Tech Prom".</p>
                            </div>
                        </div>

                        <div className="space-y-4">
                            <div>
                                <strong className="text-primary">Shared Resources:</strong>
                                <p className="text-sm">Curated materials to support continuous learning.</p>
                            </div>
                            <div>
                                <strong className="text-primary">Hands-on Projects:</strong>
                                <p className="text-sm">Real world experience through community-led initiatives.</p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p className="text-base sm:text-lg">
                            We believe in pioneering progress for the future through technology
                            by providing platforms where both novices and professionals can collaborate,
                            learn, and grow.
                        </p>
                    </div>
                </div>

                {/* Image Section */}
                <div className="relative flex justify-center items-center">
                    <img
                        src="/images/3diconsMic.png"
                        alt=""
                        className="hidden z-10 lg:block absolute w-24 top-[-2rem] right-[25rem] h-24"
                    />

                    {/* Main Image */}
                    <img
                        src="/images/communityHeroImg.jpg"
                        alt="A male community member at an event"
                        loading="lazy"
                        className="relative object-cover shadow-md w-64 sm:w-80 h-64 sm:h-96 rounded-2xl shadow-accent"
                    />

                    <img
                        src="/images/jigsaw.png"
                        alt=""
                        className="w-16 h-16 hidden right-[26rem] lg:block absolute bottom-[2rem] ml-4 md:ml-8 xl:ml-36"
                    />
                </div>
            </div>
        </section>
    );
}
